import { useCallback, useState } from "react";
import { useAPI } from "../../providers/ApiProvider";

const downloadBlob = (blob, filename) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
};

/**
 * Shared export download: the same call the Export modal makes, reused
 * by the full-page Preview so "Export" there produces the identical
 * file (format + scope + shape).
 */
export const useExportDownload = (projectId) => {
  const api = useAPI();
  const [downloading, setDownloading] = useState(false);
  const [issue, setIssue] = useState(null);

  const download = useCallback(
    async ({ format = "JSON", viewId = null, shape = null, downloadAllTasks = false } = {}) => {
      setIssue(null);
      setDownloading(true);
      try {
        const params = { pk: projectId, exportType: format, download_all_tasks: downloadAllTasks ? "true" : "false" };
        if (viewId) params.view = viewId;
        if (shape?.annotationChoice && shape.annotationChoice !== "all")
          params.annotation_choice = shape.annotationChoice;
        if (shape?.fields?.length) params.fields = shape.fields.join(",");
        const response = await api.callApi("exportRaw", { params });
        if (!response) {
          setIssue("timeout");
          return false;
        }
        if (response.ok) {
          const blob = await response.blob();
          downloadBlob(blob, response.headers.get("filename") || `project-${projectId}.${format.toLowerCase()}`);
          return true;
        }
        if (response.status === 408 || response.status === 502 || response.status === 504) {
          setIssue("timeout");
          return false;
        }
        api.handleError(response);
        return false;
      } finally {
        setDownloading(false);
      }
    },
    [api, projectId],
  );

  return { download, downloading, issue };
};
